import { $api } from '@service/RequestService';
import { Pagination } from '@utils/models/Pagination';
import { useQuery } from 'react-query';

import { cashbackConstants, cashbackModels } from '..';
import { timeStampToDate } from '@utils/index';

export const useCashbackPaymentFilter = (props: { clientId?: number; page?: number; size?: number } = {}) =>
  useQuery<Pagination<cashbackModels.ICashbackPayment>>({
    queryKey: [cashbackConstants.queryKeys.CASHBACK_PAYMENT_FILTER, props],
    queryFn: async () => {
      const res = await $api.post('/v1/cashback-payment/filter', {
        page: 1,
        size: 10,
        ...props
      });

      const data: Pagination<cashbackModels.ICashbackPayment> = res?.data?.data

      return data ?
        {
          ...data,
          data: data?.data?.map(item => ({
            ...item,
            createdDate: timeStampToDate({ date: item?.createdDate, timeStamp: item?.createdTimestamp })
          }))
        } :
        res?.data?.data;
    },
    enabled: !!props?.clientId
  });
